var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2818 6.18002C10.845 6.05918 11.4216 5.99877 12 6.00002C17.7273 6.00002 21 12 21 12C20.5033 12.8517 19.911 13.6536 19.2327 14.3925M13.6471 13.6471C13.4224 13.8682 13.2389 13.9884 12.9378 14.1113C12.6367 14.2343 12.3116 14.3005 11.9821 14.3058C11.6525 14.3111 11.3251 14.2555 11.0195 14.1424C10.7139 14.0292 10.4362 13.8608 10.2031 13.6471C9.97007 13.4335 9.78632 13.179 9.66287 12.8988C9.53942 12.6186 9.47879 12.3185 9.48461 12.0164C9.49042 11.7143 9.56256 11.4164 9.69672 11.1404C9.83087 10.8644 10.0243 10.616 10.2655 10.41M16.5 16.5C15.1014 17.4773 13.7584 17.9736 12 18C6.27273 18 3 12 3 12C3.75 10.5 5.25 9 7.5 7.5L16.5 16.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.bfc3afdcd91768b2b180a06952119044.svg";
export { ForwardRef as ReactComponent };